import { makeStyles } from '@material-ui/core'

import { getFont, lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  channelRow: {
    display: 'grid',
    gridTemplateColumns: '4.121fr 1.299fr repeat(14,1fr)',
    height: 40,
    alignItems: 'center',
    backgroundColor: theme.palette.grey[200]
  },
  channelRowForMonth: {
    gridTemplateColumns: '9.122fr 2.878fr repeat(31,1fr)'
  },
  rowName: {
    marginLeft: 58,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: 15
  },
  rowNameContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '3%'
  },
  channelArrowRight: {
    marginRight: 6,
    fontSize: 14,
    transition: `transform 0.2s`,
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`
  },
  channelArrowDown: {
    transform: `rotate(${lang === 'fa' ? '-90deg' : '90deg'})`
  },
  numberOfChannels: {
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },
  priceClassLoading: {
    width: 14,
    marginRight: 6,
    marginLeft: 4,
    marginTop: 4
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  emptyBox: {
    height: '100%',
    borderLeft: `1px solid ${theme.palette.grey[300]}`
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2',
    borderLeft: `1px solid ${theme.palette.grey[300]}`,
    borderTop: `1px solid ${theme.palette.grey[300]}`
  },
  menuContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: 'gray',
    'box-sizing': 'border-box',
    height: '100%',
    borderLeft: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`,
    '& input': {
      fontSize: 13,
      width: '98%',
      textAlign: 'center',
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      color: theme.palette.type === 'dark' ? 'white' : 'black',
      fontFamily: getFont()
    }
  }
}))

export default useStyles
